/**************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/

export const isPriceRange = price_range => {
    return (
        !!price_range.maximum_price &&
        price_range.minimum_price.final_price.value !== price_range.maximum_price.final_price.value
    );
};

/**
 * Formats prices of a price_range object.
 *
 * @param {Object} price_range Magento price_range object
 * @param {Function} formatNumber formatNumber function from react-intl
 * @returns Object with formatted prices
 */
export const formatPrices = (price_range, formatNumber) => {
    const { minimum_price, maximum_price } = price_range;

    const isRange = isPriceRange(price_range);
    const isDiscounted = !!(
        (minimum_price.discount && minimum_price.discount.amount_off > 0) ||
        (maximum_price && maximum_price.discount && maximum_price.discount.amount_off > 0)
    );

    const format = value => formatNumber(value, { style: 'currency', currency: minimum_price.final_price.currency });

    let regular_price;
    if (minimum_price.regular_price) {
        regular_price = isRange
            ? `${format(minimum_price.regular_price.value)} - ${format(maximum_price.regular_price.value)}`
            : format(minimum_price.regular_price.value);
    }

    let final_price;
    if (minimum_price.final_price) {
        final_price = isRange
            ? `${format(minimum_price.final_price.value)} - ${format(maximum_price.final_price.value)}`
            : format(minimum_price.final_price.value);
    }

    let discount_amount;
    if (minimum_price.discount) {
        discount_amount = isRange
            ? `${format(minimum_price.discount.amount_off)} - ${format(maximum_price.discount.amount_off)}`
            : format(minimum_price.discount.amount_off);
    }

    return {
        regular_price,
        final_price,
        isDiscounted,
        discount_amount
    };
};
